/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertRfiMessage,
    InternalApiAlertRfiMessageFromJSON,
    InternalApiAlertRfiMessageToJSON,
    InternalApiAlertRfiMessagesPage,
    InternalApiAlertRfiMessagesPageFromJSON,
    InternalApiAlertRfiMessagesPageToJSON,
    InternalApiCreateAlertRfiMessage,
    InternalApiCreateAlertRfiMessageFromJSON,
    InternalApiCreateAlertRfiMessageToJSON,
} from '../models';

export interface AddMessageRequest {
    alertRfiId: string;
    internalApiCreateAlertRfiMessage: InternalApiCreateAlertRfiMessage;
}

export interface FindAllAlertRfiMessagesRequest {
    alertRfiId: string;
    page: number;
    size: number;
}

/**
 * 
 */
export class AlertRfiMessageApi extends runtime.BaseAPI {

    /**
     * Create a message
     */
    async addMessageRaw(requestParameters: AddMessageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertRfiMessage>> {
        if (requestParameters.alertRfiId === null || requestParameters.alertRfiId === undefined) {
            throw new runtime.RequiredError('alertRfiId','Required parameter requestParameters.alertRfiId was null or undefined when calling addMessage.');
        }

        if (requestParameters.internalApiCreateAlertRfiMessage === null || requestParameters.internalApiCreateAlertRfiMessage === undefined) {
            throw new runtime.RequiredError('internalApiCreateAlertRfiMessage','Required parameter requestParameters.internalApiCreateAlertRfiMessage was null or undefined when calling addMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-rfi/{alertRfiId}`.replace(`{${"alertRfiId"}}`, encodeURIComponent(String(requestParameters.alertRfiId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateAlertRfiMessageToJSON(requestParameters.internalApiCreateAlertRfiMessage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertRfiMessageFromJSON(jsonValue));
    }

    /**
     * Create a message
     */
    async addMessage(requestParameters: AddMessageRequest, initOverrides?: RequestInit): Promise<InternalApiAlertRfiMessage> {
        const response = await this.addMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all messages for alert rfi conversation
     */
    async findAllAlertRfiMessagesRaw(requestParameters: FindAllAlertRfiMessagesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAlertRfiMessagesPage>> {
        if (requestParameters.alertRfiId === null || requestParameters.alertRfiId === undefined) {
            throw new runtime.RequiredError('alertRfiId','Required parameter requestParameters.alertRfiId was null or undefined when calling findAllAlertRfiMessages.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllAlertRfiMessages.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllAlertRfiMessages.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-rfi/{alertRfiId}`.replace(`{${"alertRfiId"}}`, encodeURIComponent(String(requestParameters.alertRfiId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAlertRfiMessagesPageFromJSON(jsonValue));
    }

    /**
     * Get all messages for alert rfi conversation
     */
    async findAllAlertRfiMessages(requestParameters: FindAllAlertRfiMessagesRequest, initOverrides?: RequestInit): Promise<InternalApiAlertRfiMessagesPage> {
        const response = await this.findAllAlertRfiMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
